import { z } from 'zod';
import { DocumentEntityTypeSchema, DocumentRecordRefSchema } from './document-link.js';
export const AssetSupportingDocumentSchema = z.object({
    id: z.string().uuid(),
    filename: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number().int(),
    createdAt: z.iso.datetime(),
});
/**
 * One row of an asset's document list: the asset's own documents (`ASSET`) and,
 * for an asset registered from an expense, that expense's documents
 * (`SUPPLIER_INVOICE`). `record` says which record holds the document, so a
 * reader fetches and removes it through that record's own routes.
 */
export const AssetSupportingDocumentListItemSchema = AssetSupportingDocumentSchema.extend({
    record: DocumentRecordRefSchema.extend({
        entityType: DocumentEntityTypeSchema.extract(['ASSET', 'SUPPLIER_INVOICE']),
    }),
});
/** Own documents first, then the source expense's; ids are unique. `warnings` is non-empty exactly when `documents` is empty. */
export const AssetSupportingDocumentListResponseSchema = z.object({
    documents: z.array(AssetSupportingDocumentListItemSchema),
    warnings: z.array(z.literal('NO_SUPPORTING_DOCUMENTS')),
});
